import { z } from 'zod';
import UIStrings from '@/Utils/UIStrings';
import ValidationErrors from '@/Utils/ValidationErrors';

export interface ClientFilters {
    // zero-ed value has no meaning and will not be applied
    search?: string | null;
}

export const clientSchema = z.object({
    name: z
        .string()
        .min(1, { message: ValidationErrors.Required })
        .max(128, { error: ({ maximum }) => UIStrings.MaxSymbolsValidationError(maximum) }),
    websiteURL: z
        .httpUrl({ message: ValidationErrors.UrlFieldMustBeAValidUrl })
        .max(128, { error: ({ maximum }) => UIStrings.MaxSymbolsValidationError(maximum) }),
    linkedInURL: z.union([
        z.literal(''),
        z
            .httpUrl({ message: ValidationErrors.UrlFieldMustBeAValidUrl })
            .max(128, { error: ({ maximum }) => UIStrings.MaxSymbolsValidationError(maximum) }),
    ]),
    description: z.string(),
});

export type ClientFormValues = z.infer<typeof clientSchema>;

export const clientFormFieldNames: { [key in keyof ClientFormValues]: key } = {
    name: 'name',
    websiteURL: 'websiteURL',
    linkedInURL: 'linkedInURL',
    description: 'description',
};
